import { csv, json } from 'd3';
import { initFilters } from '../stores/filter';
import Airtable from 'airtable';

const splitValue = (value) =>
  value
    .split(',')
    .map((d) => d.trim())
    .map((d) => d === '' ? 'Undecided' : d);

const curate = (value) => {
  if (!value) return 'Undecided';
  return value.replace('n/a', 'Undecided');
};

export const loadTrackerData = async (dataPath) => {
  // load and format the data
  const data = await csv(dataPath, (d) => {
    let mediaSources;
    if (d['Media Sources'] !== undefined) {
      mediaSources = d['Media Sources'].split(';').filter(dd => dd);
    } else {
      mediaSources = '';
    }
    return {
      owner: d.Owner,
      name: d.Name,
      currency_name: d['Name of CBDC'],
      overview: d.Overview,
      overview_spotlight: d['Overview Spotlight'],
      key_developments: d['Key Developments'],
      key_developments_spotlight: d['Key Developments Spotlight'],
      categories: {
        // former version
        // new_status: curate(d['New Status']),
        new_status: curate(d['October Status']),
        use_case: curate(d['Use case']),
        technology: curate(d['Underlying technology']),
        architecture: curate(d['Architecture: direct CBDC or hybrid']),
        infrastructure: curate(d['Infrastructure: DLT or conventional']),
        access: curate(d['Access: token or account']),
        corporate_partnership: curate(d['Technology partnership']),
        crossborder_partnerships: curate(d['Cross-border projects']),
      },
      sources: {
        central_bank_name: d['Central Bank Name'],
        central_bank_url: d['Central Bank Source to Hyperlink'],
        // media_urls: d['Media Sources'].split(';').filter(dd => dd)
        media_urls: d['Media Sources'].split(';').filter(dd => dd)
      },
      notes: d.Notes,
    };
  });

  // filter for valid entries
  const filteredData = data
    .filter(
      (d) => d.categories.new_status !== 'not available'
    )
    .filter(
      (d) => d.categories.new_status !== 'Undecided'
    )
    .filter(
      (d) => d.categories.new_status !== 'No development yet'
    );

  // initialize the filters
  initFilters(filteredData);

  return filteredData;
};

export const loadJson = async (dataPath) => {
  return await json(dataPath);
};

export const loadNaturalEarth = async (dataPath) => {
  const { features } = await json(dataPath);
  return features.map(d => {
    return {
      ...d,
      properties: {
        name: d.properties.ADMIN
      }
    };
  });
};

export const loadCapitals = async (dataPath) => {
  return await csv(dataPath);
};


const curateYesNo = (value) => {
  if (typeof value === 'undefined') return '';
  return value;
};


const curateBoolean = (value) => {
  if (typeof value === 'undefined') return false;
  return value;
};

const curateString = (value) => {
  if (typeof value === 'undefined') return '';
  if (typeof value === 'object') return value.join(', ');
  return value;
};




export const loadTrackerData2 = async () => {

  //Airtable.configure( { apiKey: 'keyiBpVib7jEKXnEH' } );

  Airtable.configure({
    endpointUrl: 'https://api.airtable.com',
    apiKey: 'patRjIoyO5Pin31nV.fe04c3c1b50fbd3e685f172a163855c312291b75b4f01477b7c854a5377044d4'
  });

  let base = new Airtable().base( 'appDvpjQzhIjaHc25' );

  // load and format the data
  const data = await base('Table 1').select().all().then(records => {
    //console.log(records); // DEBUG
    let rows = records.map(function(record,index, array){
      //console.log(record.get('Country'));
      return {
        review: curateBoolean(record.get('Lead Complete?')),
        name: curateString(record.get('Country')),
        currency_name: curateString(record.get('Name of CBDC')),
        overview: curateString(record.get('Overview')),
        overview_spotlight: '',
        key_developments: curateString(record.get('Key Developments')),
        key_developments_spotlight: '',
        timeline: curateString(record.get('Timeline')),
        crossborder_projects: curateString(record.get('Cross-border projects Content')),
        motivations: curateString(record.get('Motivations')),
        categories: {
          new_status: curateString(record.get('Present Status')),
          use_case: curateString(record.get('Use case')),
          technology: curateString(record.get('Underlying technology')),
          architecture: curateString(record.get('Architecture: direct CBDC or hybrid')).toString(),
          infrastructure: curateString(record.get('Infrastructure: DLT or conventional')),
          access: 'Undecided',
          corporate_partnership: curateString(record.get('Technology partnership')),
          crossborder_partnerships: curateString(record.get('Cross-border projects')),
        },
        sources: {
          central_bank_name: curateString(record.get('Central Bank Name')),
          central_bank_url: curateString(record.get('Central Bank Source to Hyperlink')),
          media_urls: curateString(record.get('Media Sources')).split(';').filter(dd => dd)
        },
        notes: curateString(record.get('Notes'))
      }
    }).filter(dd => (dd.categories.new_status !== ''));
    return rows;
  });

  // initialize the filters
  initFilters(data);


  return data;

  /*
  await csv(dataPath, (d) => {
    let mediaSources;
    if (d['Media Sources'] !== undefined) {
      mediaSources = d['Media Sources'].split(';').filter(dd => dd);
    } else {
      mediaSources = '';
    }
    return {
      owner: d.Owner,
      name: d.Name,
      currency_name: d['Name of CBDC'],
      overview: d.Overview,
      overview_spotlight: d['Overview Spotlight'],
      key_developments: d['Key Developments'],
      key_developments_spotlight: d['Key Developments Spotlight'],
      categories: {
        // former version
        // new_status: curate(d['New Status']),
        new_status: curate(d['October Status']),
        use_case: curate(d['Use case']),
        technology: curate(d['Underlying technology']),
        architecture: curate(d['Architecture: direct CBDC or hybrid']),
        infrastructure: curate(d['Infrastructure: DLT or conventional']),
        access: curate(d['Access: token or account']),
        corporate_partnership: curate(d['Technology partnership']),
        crossborder_partnerships: curate(d['Cross-border projects']),
      },
      sources: {
        central_bank_name: d['Central Bank Name'],
        central_bank_url: d['Central Bank Source to Hyperlink'],
        // media_urls: d['Media Sources'].split(';').filter(dd => dd)
        media_urls: d['Media Sources'].split(';').filter(dd => dd)
      },
      notes: d.Notes,
    };
  });
  */

}

